// src/pushClient.ts
export const VAPID_PUBLIC_KEY = 'BEUERtoR2a9GB6M6Lstpc86HQGc9GyObq0WlBVjUdtDFUztoEst8zXRu_V7uYpSnj6YJMWSIJtnuMLu_xD3CKM8';

export function urlBase64ToUint8Array(base64String: string) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  const raw = atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) output[i] = raw.charCodeAt(i);
  return output;
}
